<template>
    <div id="progresser">
      <img src="~@/assets/img/logo-symbol.svg"/>
      <div class="progress">
          <progressBar ref="progress_bar" :neverEnding="neverEnding"/>
      </div>
      <div class="text" v-if="text" v-html="text"></div>
    </div>
</template>

<script>
export default {
  props: {
    neverEnding: Boolean
  },
  data () {
    return {
      text: ''
    }
  },
  methods: {
    start (elapsed, total, textKey) {
      // Reset
      this.stop()
      this.text = ''

      // Update text
      this.updateText(elapsed, total, textKey)

      // Start progress bar
      this.$refs.progress_bar.start(elapsed, total, function (elapsed) {
        // Update text
        this.updateText(elapsed, total, textKey)
      }.bind(this))
    },
    updateText (elapsed, total, textKey) {
      const d = total - elapsed
      var duration = ''
      if (d >= 2 * 60 * 1e9) {
        duration = 'more than 2 minutes'
      } else if (d > 60 * 1e9) {
        duration = 'less than 2 minutes'
      } else if (d > 30 * 1e9) {
        duration = 'less than 1 minute'
      } else {
        duration = 'a few seconds'
      }
      this.text = this.$t(textKey, { duration: duration })
    },
    stop () {
      // Stop progress bar
      this.$refs.progress_bar.stop()
    }
  }
}
</script>

<style>

#progresser {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#progresser > img {
  animation:rotate 2s linear infinite;
  height: 4em;
  margin-bottom: 1em;
}
@keyframes rotate{
  to{ transform: rotate(360deg); }
}

#progresser .progress {
  margin: 0 auto 1em auto;
  width: 23em;
}

</style>
